import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 160, height = 160, color = 'currentColor', customClass }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 160 160' class={customClass} >
  <rect width='160' height='160' fill='#3C66CB'/>
  <path d='M32 43.8056C32 37.2856 37.2047 32 43.625 32H116.375C122.795 32 128 37.2856 128 43.8056V47.7091H32V43.8056Z' fill='white' />
  <path d='M32 82.618H97.4545V128H43.6114C37.1986 128 32 122.751 32 116.276V82.618Z' fill='white' />
  <path d='M128 56.4363H32V73.1313H108.125V128H116.375C122.795 128 128 122.793 128 116.37V56.4363Z' fill='white' />
</svg>
